module.exports = __webpack_public_path__ + "static/manningham-be15862260f46a83a2146a243d78e969.png";